"use client";

import { cn } from "@/lib/utils";

interface AnnotationCalloutProps {
  label: string;
  value: string;
  className?: string;
}

export function AnnotationCallout({
  label,
  value,
  className,
}: AnnotationCalloutProps) {
  return (
    <div className={cn("annotation-callout", className)}>
      <span className="text-muted-foreground">{label}</span>{" "}
      <span className="font-semibold text-foreground">{value}</span>
    </div>
  );
}
